module.exports = __webpack_public_path__ + "static/media/unauthorized-icon.362c9334.png";